import { ErrorAlert } from './ErrorAlert';
import { InfoAlert } from './InfoAlert';

export interface PerformanceAlertsProps {
  questionCount: number | undefined;
  isRestricted: boolean;
  isSupportedDateRange: boolean;
  onUpsell: () => void;
  error: string | null;
}

export const PerformanceAlerts = ({
  questionCount,
  isRestricted,
  onUpsell,
  isSupportedDateRange,
  error,
}: PerformanceAlertsProps): JSX.Element => {
  return (
    <>
      <InfoAlert
        isRestricted={isRestricted}
        isSupportedDateRange={isSupportedDateRange}
        onUpsell={onUpsell}
        questionCount={questionCount}
      />
      <ErrorAlert error={error} />
    </>
  );
};
